import { render, staticRenderFns } from "./task-history.vue?vue&type=template&id=4fccd2a0&"
import script from "./task-history.vue?vue&type=script&lang=js&"
export * from "./task-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports